import { render, staticRenderFns } from "./FileEditDialog.vue?vue&type=template&id=63ce6de4"
import script from "./FileEditDialog.vue?vue&type=script&lang=ts"
export * from "./FileEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./FileEditDialog.vue?vue&type=style&index=0&id=63ce6de4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports